import reducer, * as fromNotifications from './reducer';
import * as notificationsService from './utils';

export default reducer;
export { fromNotifications };
export { notificationsManager } from './actions';
export { notificationsService };
